import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getAdminDashboardApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data, apiConstants.USER.GET_ADMIN_DASHBOARD)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
